<template>
  <div class="site-main">
    <div v-if="message.type" class="message-block">
      <full-page-message
        :type="message.type"
        :message="message.text"
        :role="$store.getters.userDisplayRole"
      ></full-page-message>
    </div>
    <app-header :title="$t('customized_data_upload_mainpage_title')" v-if="!message.type"></app-header>
    <div class="main-block" v-if="!message.type">
      <app-sidebar :isLogin="isOnLoginPage()"></app-sidebar>
      <div class="main-content">
        <div class="main-item">
          <div class="update__block">
            <div class="upload__block">
              <div class="upload__content">{{ $t('customized_data_upload_intro') }}</div>
              <hr class="item_hr" />
              <div class="main-button mt-40" v-on:click="getDataStatus">
                {{ $t('customized_data_upload_button_refresh') }}
              </div>
            </div>
            <div class="status__block" v-for="(item, index) in customerTable" v-bind:key="index">
              <label class="table__title mr-20">{{ $t(`customized_data_upload_title_${item}`) }}</label>
              <label
                for="file-upload"
                class="custom-dataset-upload main-button status__refresh mt-30"
                :disabled="status.datasetRunning"
                >{{ $t('customized_data_upload_button_upload') }}</label
              >
              <input
                id="file-upload"
                type="file"
                accept=".zip"
                v-on:change="uploadFile(item)"
                v-on:click="resetUpload"
              />
              <div class="status__block__list status__block__head mt-30">
                <div class="status__block__list-item">{{ $t('customized_data_upload_subtitle_filename') }}</div>
                <div class="status__block__list-item">{{ $t('customized_data_upload_subtitle_status') }}</div>
                <div class="status__block__list-item">{{ $t('customized_data_upload_subtitle_err') }}</div>
                <div class="status__block__list-item">{{ $t('customized_data_upload_subtitle_uploader') }}</div>
                <div class="status__block__list-item">{{ $t('customized_data_upload_subtitle_utime') }}</div>
                <div class="status__block__list-item">{{ $t('customized_data_upload_button_delete') }}</div>
              </div>
              <div
                class="status__block__list status__block__content"
                v-for="(item, index) in getDataStatusByDimension(item)"
                v-bind:key="index"
              >
                <div class="status__block__list-item">{{ item.data_ver }}</div>
                <div class="status__block__list-item">{{ $t(`table_update_status_${item.status}`) }}</div>
                <div class="status__block__list-item">{{ item.err_msg }}</div>
                <div class="status__block__list-item">{{ item.uploader }}</div>
                <div class="status__block__list-item">{{ item.upload_time | dtFormat }}</div>
                <div class="status__block__list-item">
                  <div class="second-button button--delete" v-on:click="deleteCustomerTable(item.id)">刪除</div>
                </div>
              </div>
              <div
                v-if="getDataStatusByDimension(item).length === 0"
                class="status__block__content status__block__content--empty"
              >
                {{ $t('customized_data_upload_empty', { table: $t(`customized_data_upload_title_${item}`) }) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-item" v-if="dialog.type" v-on:click="hidePanel">
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'datasetIsRunning'">
        <div class="dialog__title">{{ $t('dataset_update_client_error_dialog_job_is_running_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_client_error_dialog_job_is_running_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_client_error_dialog_job_is_running_button')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'datasetIsPending'">
        <div class="dialog__title">{{ $t('dataset_update_client_error_dialog_job_is_pending_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_client_error_dialog_job_is_pending_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_client_error_dialog_job_is_pending_button_no')
          }}</a>
          <a class="main-button dialog__button" v-on:click="forceUpload">{{
            $t('dataset_update_client_error_dialog_job_is_pending_button_yes')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'FileUploadFail'">
        <div class="dialog__title">{{ $t('dataset_update_upload_api_err_file_upload_fail_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_upload_api_err_file_upload_fail_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_upload_api_err_file_upload_fail_button')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'InvalidFileFormat'">
        <div class="dialog__title">{{ $t('dataset_update_client_error_dialog_filename_invalid_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_client_error_dialog_filename_invalid_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_client_error_dialog_filename_invalid_button')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'InvalidFileContent'">
        <div class="dialog__title">{{ $t('dataset_update_upload_api_err_invalid_file_content_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_upload_api_err_invalid_file_content_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_upload_api_err_invalid_file_content_button')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'InvalidDataVersion'">
        <div class="dialog__title">{{ $t('dataset_update_upload_api_err_version_invalid_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_upload_api_err_version_invalid_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_upload_api_err_version_invalid_button')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'UncompressFileError'">
        <div class="dialog__title">{{ $t('dataset_update_upload_api_err_uncompress_file_title') }}</div>
        <div class="dialog__desc mt-20">{{ $t('dataset_update_upload_api_err_uncompress_file_desc') }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">{{
            $t('dataset_update_upload_api_err_uncompress_file_button')
          }}</a>
        </div>
      </div>
      <div class="dialog" id="dialog-main" v-if="dialog.type === 'APIError'">
        <div class="dialog__title">APIError</div>
        <div class="dialog__desc mt-20">{{ dialog.text }}</div>
        <div class="dialog__btns mt-60">
          <a class="main-button dialog__button" v-on:click="dismissDialog">我知道了</a>
        </div>
      </div>
    </div>
    <div class="full-loading" v-if="status.uploading">
      <full-page-loading :message="$t('dataset_update_uploading_hint')"></full-page-loading>
    </div>
    <div class="full-loading" v-if="status.deleting">
      <full-page-loading :message="$t('dataset_update_deleting_hint')"></full-page-loading>
    </div>
    <div class="full-loading" v-if="status.jobRunning">
      <full-page-loading :message="$t('dataset_update_job_running_hint')"></full-page-loading>
    </div>
    <div id="canvas-img"></div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

import { apiDataStatus, apiDataUpload, apiDataDelete } from '../api.js';
import FullPageMessage from './partials/FullPageMessage.vue';
import FullPageLoading from './partials/FullPageLoading.vue';
import Header from './base/header.vue';
import Sidebar from './base/sidebar.vue';

export default {
  name: 'DatasetUpdate',
  props: {
    msg: String,
  },
  data() {
    return {
      customerTable: process.env.VUE_APP_CUSTOMER_TABLE.split(', '),
      statusData: {},
      datasetFile: new FormData(),
      status: {
        uploading: false,
        deleting: false,
      },
      dialog: {
        type: null,
      },
      message: {
        type: null,
        text: null,
        apiError: null,
      },
    };
  },
  components: {
    'app-header': Header,
    'app-sidebar': Sidebar,
    'full-page-loading': FullPageLoading,
    'full-page-message': FullPageMessage,
  },
  created() {
    const $ = this;
    $.getDataStatus();
  },
  filters: {
    roundToInt: function (value) {
      return Math.round(value);
    },
    dtFormat: function (datetime) {
      if (!datetime) return '';
      return moment.tz(datetime, 'UTC').tz('Asia/Taipei').format('YYYY-MM-DD HH:mm:ss');
    },
  },
  methods: {
    getDataStatusByDimension: function (dimension) {
      if (dimension in this.statusData) return this.statusData[dimension];
      return [];
    },
    resetUpload: function (e) {
      e.target.value = null;
    },
    uploadFile: function (dimension) {
      const fileLoader = document.getElementById('file-upload');
      const $ = this;

      if (fileLoader.files.length > 0 && !$.checkCustomTableFileNameFormat(fileLoader.files[0].name, dimension)) {
        $.getDataStatus();
        $.status.uploading = true;
        $.dataUpload();
      } else {
        $.dialog.type = 'InvalidFileFormat';
      }
    },
    dataUpload: function () {
      const fileLoader = document.getElementById('file-upload');
      const $ = this;

      $.datasetFile.append('files', fileLoader.files[0]);

      apiDataUpload($.datasetFile)
        .then(function () {})
        .catch(function (error) {
          if (error.response.status === 400) {
            if (error.response.data.msg === 'FILE_UPLOAD_FAIL') {
              $.dialog.type = 'FileUploadFail';
            } else if (error.response.data.msg === 'INVALID_FILE_FORMAT') {
              $.dialog.type = 'InvalidFileFormat';
            } else if (error.response.data.msg === 'INVALID_FILE_CONTENT') {
              $.dialog.type = 'InvalidFileContent';
            } else if (error.response.data.msg === 'FILE_CANNOT_OPEN') {
              $.dialog.type = 'FileCanNotOpen';
            } else if (error.response.data.msg === 'INVALID_DATA_VERSION') {
              $.dialog.type = 'InvalidDataVersion';
            } else if (error.response.data.msg === 'UNCOMPRESS_FILE_ERROR') {
              $.dialog.type = 'UncompressFileError';
            }
          } else {
            $.message.type = 'APIError';
            $.message.text = Object.getOwnPropertyDescriptor(error, 'message').value;
            $.linkInvalid = true;
            $.link_error = error.response.data.msg;
          }
        })
        .finally(function () {
          $.getDataStatus();
          $.status.uploading = false;
          $.datasetFile = new FormData();
        });
    },
    forceUpload: function () {
      const $ = this;
      $.dismissDialog();
      $.dataUpload();
    },
    getDataStatus: function () {
      const $ = this;

      apiDataStatus()
        .then(function (response) {
          $.statusData = response.data;
          $.updateSystemVersion();
        })
        .catch(function (error) {
          $.singleNumberForm.numberError = Object.getOwnPropertyDescriptor(error, 'message').value;
        });
    },
    deleteCustomerTable: function (id) {
      const $ = this;
      $.status.deleting = true;

      apiDataDelete({
        id: id,
      })
        .then(function (response) {
          const res = response.data;

          if (res.status === 'failed') {
            if (res.errMsg === 'INVALID_FILE_FORMAT') {
              $.message.type = 'SearchLicenseExpire';
            }
          }
          $.getDataStatus();
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            if (error.response.data.msg === 'LICENSE_EXPIRED') {
              $.message.type = 'SearchLicenseExpire';
            }
          } else {
            $.linkInvalid = true;
            $.link_error = error.response.data.msg;
          }
        })
        .finally(function () {
          $.status.deleting = false;
        });
    },
    dismissDialog: function () {
      const $ = this;

      $.dialog.type = null;
    },
    hidePanel: function (event) {
      var dm = document.getElementById('dialog-main');

      if (dm) {
        if (!dm.contains(event.target)) {
          this.dialog.type = null;
        }
      }
    },
  },
};
</script>

<style scoped>
.site-main {
  display: flex;
  flex-direction: column;
}

.main-block {
  display: flex;
  height: calc(100vh - 60px);
}

.main-content {
  display: flex;
  box-sizing: border-box;
  flex-basis: 80%;
  flex-grow: 1;
  flex-shrink: 1;
  background-color: #eaeaea;
  overflow-y: scroll;
  z-index: 1;
  padding: 40px;
}

.main-item {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
}

.update__block {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 40px;
  margin: 0;
}

.upload__block {
  display: flex;
  padding-bottom: 40px;
  flex-direction: column;
}

.status__title__block {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload__content {
  font-size: 14px;
  color: #000000;
}

.item_hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #d8d8d8;
  margin: 56px 0 1em;
  padding: 0;
}

.table__title,
.upload__title,
.status__title {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

input[type='file'] {
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.custom-dataset-upload {
  display: inline-block;
  cursor: pointer;
  margin-left: 0;
  margin-right: 0;
  overflow: unset;
}

.status__block__list {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status__block__list-item {
  flex: 1;
  padding: 0 20px;
  word-break: break-all;
}

.status__block__head {
  min-height: 30px;
  background-color: #161616;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.status__block__content {
  display: flex;
  min-height: 60px;
  font-size: 14px;
  color: #000000;
  border-bottom: 1px solid #d8d8d8;
}

.status__block__content--empty {
  font-size: 14px;
  line-height: 60px;
  color: #000000;
}

.button--delete {
  display: inline-block;
}
</style>
